import { Easing } from 'motion';

export const defaultEasing = [0.61, 1, 0.88, 1] as Easing;

export const defaultCSSEasing = (easing: Easing = defaultEasing) => {
  return `cubic-bezier(${[...easing].join(',')})`;
};
